import React, { useState } from "react"
import { IG_USER_DATA } from "../../Enum/LOGIN_PAGE_TYPE"
import { useSelector } from "react-redux"
import { Trans, useTranslation } from "react-i18next"
import KOL from "../../Model/KOL"
import { Chart } from "react-google-charts"

import {
  returnAudienceAgeData,
  returnAudienceCityData,
  returnAudienceGenderData,
} from "../../HelpingFunction/FollowersData/FollowerDBHelper"
import { getCountry } from "../../Utils/Countries"
import KOLFollowerInterest from "./KOLFollowerInterest"
import KOLIGStylePreview from "../../Component/KOLIGStylePreview"

const KOLInsights = () => {
  const { t } = useTranslation()

  const igKOLData: IG_USER_DATA = useSelector((state: any) => {
    return state.KOLInfoManager.igKOLData
  })
  const profile: KOL = useSelector((state: any) => {
    return state.KOLInfoManager.kolInfo
  })

  const [isPercentage, setIsPercentage] = useState<boolean>(false)

  const sortArray = (arr: any[]): string => {
    let temp = arr.sort((a, b) => {
      return b[1] - a[1]
    })

    return temp[0][0]
  }
  const sortPercentage = (arr: any[]): string => {
    let temp = arr.sort((a, b) => {
      return b[1] - a[1]
    })
    let sum = arr
      .map((e) => e[1])
      .reduce((a, b) => {
        return a + b
      })

    return Math.round((temp[0][1] / sum) * 100).toString()
  }

  const getCountryName = (): string => {
    let count = getCountry(
      returnAudienceCityData(igKOLData.audience_country, 100)[0][0]
    )
    return count.label
  }
  const getCountryPercentage = (): string => {
    let topCount = returnAudienceCityData(igKOLData.audience_country, 100)[0][1]
    let sum = returnAudienceCityData(igKOLData.audience_country, 100)
      .map((e) => e[1])
      .reduce((a, b) => {
        return a + b
      })
    return Math.round((topCount / sum) * 100).toString()
  }

  const isChartShow =
    typeof igKOLData.audience_country === "object" &&
    Object.keys(igKOLData.audience_country).length

  return (
    <div className="w-full md:pt-2 pt-6 md:grid grid-cols-1 lg:grid-cols-2 md:gap-4 md:px-0 px-4">
      <section className="w-full mb-8 ">
        <KOLIGStylePreview
          avatarUrl={profile.avatarUrl}
          userName={profile.userName}
          numOfPosts={igKOLData.numOfPosts}
          numOfFollowers={igKOLData.numOfFollowers}
          numOfFollowing={igKOLData.numOfFollowing}
          imagesList={igKOLData.imagesList}
        />
      </section>

      {/* Follower location*/}
      <section className="w-full my-4 pl-4 text-left border-l-4 border-red-300">
        <p className="text-2xl text-left font-medium text-red-default">
          <Trans>LocationEditRow.title</Trans>
        </p>

        {isChartShow ? (
          <div>
            <p className="mt-2 text-gray-500 text-sm">
              <span className="text-primary">{getCountryPercentage()}% </span>
              <Trans>KOLProfile.fol-country</Trans>{" "}
              <span className="text-primary">{getCountryName()}</span>
            </p>
            <div className="relative">
              <Chart
                width={"100%"}
                height={400}
                chartType="GeoChart"
                loader={<div>Loading Chart</div>}
                data={[
                  ["Country", "Popularity"],
                  ...returnAudienceCityData(igKOLData.audience_country, 100),
                ]}
                // For tests
                rootProps={{ "data-testid": "2" }}
              />
              <div
                className=" absolute right-0 bottom-0 border-2 rounded-md"
                style={{
                  width: "200px",
                  height: "130px",
                }}>
                <div
                  className="absolute z-10 font-bold  text-gray-700 p-2"
                  style={{ zIndex: 5 }}>
                  <Trans>ViewFollowersDetailModal.hong-kong</Trans>
                </div>
                <Chart
                  chartType="GeoChart"
                  loader={<div>Loading Chart</div>}
                  data={[
                    ["Country", "Popularity"],
                    ...returnAudienceCityData(igKOLData.audience_country, 100),
                  ]}
                  options={{ region: "HK" }}
                  // For tests
                  rootProps={{ "data-testid": "2" }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className=" text-gray-400 my-4">
            <Trans>ViewFollowersDetailModal.data-not-found</Trans>
          </div>
        )}
      </section>

      {/* Follower gender*/}
      <section className="w-full my-4 pl-4 text-left border-l-4 border-red-300">
        <p className="text-2xl text-left font-medium  text-red-default">
          <Trans>GenderEditRow.title</Trans>
        </p>

        {isChartShow ? (
          <div>
            <p className="mt-2 text-sm text-gray-500">
              <span className="text-primary">
                {sortPercentage(
                  returnAudienceGenderData(
                    igKOLData.audience_gender_age,
                    isPercentage
                  )
                )}
                %{" "}
              </span>
              <Trans>KOLProfile.fol-gender</Trans>{" "}
              <span className="text-primary">
                {sortArray(
                  returnAudienceGenderData(
                    igKOLData.audience_gender_age,
                    isPercentage
                  )
                )}
              </span>
            </p>
            <Chart
              width={"100%"}
              height={"200px"}
              chartType="PieChart"
              loader={<div>Loading Chart</div>}
              data={[
                [t("GenderEditRow.gender"), t("IGFollowDataEditor.percentage")],
                ...returnAudienceGenderData(
                  igKOLData.audience_gender_age,
                  isPercentage
                ),
              ]}
              options={{
                chartArea: { left: 0, top: 20, right: 0, bottom: 0 },
                titleTextStyle: {
                  fontSize: "16",
                  bold: true,
                },
                colors: ["#0ea5e9", "#e17d72", "#22c55e"],
              }}
              // For tests
              rootProps={{ "data-testid": "2" }}
            />
          </div>
        ) : (
          <div className=" text-gray-400 my-4">
            <Trans>ViewFollowersDetailModal.data-not-found</Trans>
          </div>
        )}
      </section>

      {/* Follower age*/}
      <section className="w-full my-4 pl-4 text-left border-l-4 border-red-300">
        <p className="text-2xl text-left font-medium  text-red-default">
          <Trans>AgeGroupEditRow.title</Trans>
        </p>

        {isChartShow ? (
          <div>
            <p className="mt-2 text-gray-500 text-sm">
              <span className="text-primary">
                {sortPercentage(
                  returnAudienceAgeData(
                    igKOLData.audience_gender_age,
                    isPercentage
                  )
                )}
                %{" "}
              </span>{" "}
              <Trans>KOLProfile.age-group</Trans>{" "}
              <span className="text-primary">
                {sortArray(
                  returnAudienceAgeData(
                    igKOLData.audience_gender_age,
                    isPercentage
                  )
                )}
              </span>
            </p>
            <Chart
              width={"100%"}
              height={"100%"}
              chartType="BarChart"
              loader={<div>Loading Chart</div>}
              data={[
                [
                  t("AgeGroupEditRow.age"),
                  isPercentage
                    ? t("IGFollowDataEditor.percentage")
                    : t("IGFollowDataEditor.count"),
                ],
                ...returnAudienceAgeData(
                  igKOLData.audience_gender_age,
                  isPercentage
                ),
              ]}
              options={{
                // Material design options
                chart: {
                  title: t("AgeGroupEditRow.title"),
                  subtitle: t("AgeGroupEditRow.description"),
                },
                colors: ["#e17d72"],
              }}
              // For tests
              rootProps={{ "data-testid": "2" }}
            />
          </div>
        ) : (
          <div className=" text-gray-400 my-4">
            <Trans>ViewFollowersDetailModal.data-not-found</Trans>
          </div>
        )}
      </section>

      {/*  Follower interest*/}
      <section className="lg:col-span-2 w-full my-4 pl-4 text-left border-l-4 border-red-300">
        <p className="text-2xl text-left font-medium  text-red-default">
          <Trans>ChatKOLInfo.follower-percentage</Trans>
        </p>
        <KOLFollowerInterest userName={profile.userName} />
      </section>
    </div>
  )
}
export default KOLInsights
